/** Row from {@code winery_subscriptions}; mirrors backend {@code WinerySubscriptionInfo}. */
export interface WinerySubscriptionInfo {
  subscriptionCode: string;
  validityStart: string | Date | null;
  validityEnd: string | Date | null;
  /** JSON from {@code winery_subscriptions.extra_metadata} (JSONB), when present. */
  extra_metadata?: Record<string, unknown> | null;
}

/** Values stored in {@code winery_subscriptions.subscription_code} (must match DB rows). */
export const WINERY_SUBSCRIPTION_CODE = {
  PRO: 'PRO',
  BASIC: 'BASIC',
  WSPOS: 'WSPOS',
} as const;
